"use strict";
import { svc_getBrandOutletCount, svc_getXeroLinkedBrands } from "@/services/brand";
import { svc_getGlobalBrandSelected, svc_saveGlobalBrandSelected, svc_getAllBrands } from "@/services/preferences";
import { svc_fetchAll, svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";
const config = require("@/../config/config.json");

const apiPrefix = "brands";

const Model = {
	namespace: "m_Brand",
	state: {
		brands: [],
		selectedGlobalBrand: {},
        globalBrands: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { brands } }) {
			return { ...state, brands };
		},
		saveGlobalBrand(state, { payload: { selectedGlobalBrand } }) {
			return { ...state, selectedGlobalBrand };
		},
        handleFetchAllBrands(state, { payload }) {
			return { ...state, globalBrands: payload };
		},
	},
	effects: {
		*fetchAll({ searchKey }, { call, put }) {
			let brands = yield call(svc_fetchAll, apiPrefix);
			
			if (!showServerResponse(brands, false)) return;
			_.forEach(brands, function (row) {
				row.key = row.id;
				row.fullAddress = `${row.primary_registered_business_address_line}, ${row.secondary_registered_business_address_line}`
			});

			yield put({
				type: "handleFetchAll",
				payload: { brands },
			});

			return brands;
		},
		*fetchSaveGlobalBrand({ searchKey }, { call, put }) {
			if (!searchKey) {
				let savedGlobalBrand = JSON.parse(localStorage.getItem("selectedGlobalBrand"));
				if (savedGlobalBrand) {
					searchKey = savedGlobalBrand["id"];
				} else {
					// try and retrieve from server the last global brand selected.
					savedGlobalBrand = yield call(svc_getGlobalBrandSelected);
					if (savedGlobalBrand) {
						searchKey = savedGlobalBrand["savedGlobalBrand"];
					} else {
						searchKey = null;
					}
				}
			}

			if (!searchKey) return;

			// always fetch for updates on this brand
			let selectedGlobalBrand = yield call(svc_fetchOne, apiPrefix, searchKey);

			yield put({
				type: "saveGlobalBrand",
				payload: { selectedGlobalBrand },
			});

			// save to localstorage for local persistency
			localStorage.setItem("selectedGlobalBrand", JSON.stringify(selectedGlobalBrand));

			// save to db for user persistency
			yield call(svc_saveGlobalBrandSelected, selectedGlobalBrand.id);

			return selectedGlobalBrand;
		},
		*fetchOutletStats({ payload }, { call, put }) {
			let brands = yield call(svc_getBrandOutletCount);
			yield put({
				type: "handleFetchAll",
				payload: { brands },
			});

			return brands;
		},
		*fetchSearch({ payload }, { call, put }) {
			const brands = yield call(svc_search, `${apiPrefix}/search`, payload);

			if (!showServerResponse(brands, false)) return;
			let brandOutlets = [];
			_.forEach(brands, function (row) {
				// add brand to brandOutlet
				row.key = `${row.id}`;
				brandOutlets.push(row);

				if (row.outlets.length > 0) {
					_.forEach(row.outlets, function (outlet) {
						// add outlet to brandOutlet
						outlet.key = `${row.id}_${outlet.id}`;
						outlet.name = `${row.name} - ${outlet.name}`;
						// outlet.brandName = row.name;
						// outlet.outletName = outlet.name;
						brandOutlets.push(outlet);
					});
				}
			});

			return brandOutlets;
		},
		*addBrand({ payload }, { call, put }) {
			delete payload.id;
			const response = yield call(svc_addOne, apiPrefix, payload);
			showServerResponse(response);
			return response;
		},
		*updateBrand({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*deleteBrand({ payload }, { call, put }) {
			if (payload && payload.id) {
				payload = _.omit(payload, ["key"]);
				const response = yield call(svc_deleteOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*fetchAllBrandsForPref({ payload = {} }, { call, put }) {
			let brands = yield call(svc_getAllBrands);
			
			if (!showServerResponse(brands, true)) return [];

            let newList = [];
            newList.push({
                id: null,
                title: "ALL BRANDS",
                type: "ALL_BRAND"
            });

            for (let brand of brands.result) {
                let brandName = brand.name;
                if (config.brandHeaderFormat?.brand == "CODE" && brand.code) {
                    brandName = brand.code;
                }

                newList.push({
                    id: brand.id,
                    title: brandName,
                    type: "BRAND"
                })

                if (payload.showOutlets && brand.outlets && brand.outlets.length > 0) {
                    for (let outlet of brand.outlets) {
                        let outletName = outlet.name;
                        if (config.brandHeaderFormat?.outlet == "CODE" && outlet.code) {
                            outletName = outlet.code;
                        }

                        newList.push({
                            id: outlet.id,
                            title: `${brandName} - ${outletName}`,
                            type: "OUTLET",
                            brand_id: brand.id,
                        })

                        if (payload.showTerminals && outlet.terminals && outlet.terminals.length > 0) {
                            for (let terminal of outlet.terminals) {
                                let terminalName = `Terminal ${terminal.terminal_no}`;
                                if (terminal.description)
                                    terminalName += ` (${terminal.description})`
                                newList.push({
                                    id: terminal.id,
                                    title: `${brandName} - ${outletName} - ${terminalName}`,
                                    type: "TERMINAL",
                                    outlet_id: outlet.id,
                                    brand_id: brand.id,
                                    terminal_no: terminal.terminal_no,
                                })
                            }
                        }
                    }
                }
            }

			yield put({
				type: "handleFetchAllBrands",
				payload: newList,
			});
			return newList;
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname, query }) => {
				if (pathname === "/menu" || pathname === "/brands" || pathname === "/payment" || pathname === "/dashboard" || pathname === "/biz-reports/rawdata" || pathname === "/biz-reports/zreports") {
					dispatch({ type: "fetchOutletStats", payload: query });
				}
			});
		},
	},
};

export default Model;
